/**
 * トップ: 注目作品カルーセル（dreampiece.jp homeFeaturedCarousel 準拠）
 */
(function () {
  const AUTOPLAY_MS = 8000;
  const MOBILE_SLIDES = 2;
  const MOBILE_MQ = window.matchMedia('(max-width: 640px)');

  function getSlidesPerView(root) {
    const raw = getComputedStyle(root).getPropertyValue('--featured-slides').trim();
    const value = Number.parseInt(raw, 10);
    if (Number.isFinite(value) && value > 0) {
      return value;
    }

    return MOBILE_MQ.matches ? MOBILE_SLIDES : 2;
  }

  function shouldUseStaticCarousel(root, cardCount, slidesPerView) {
    if (cardCount <= slidesPerView) {
      if (MOBILE_MQ.matches && cardCount > 1) {
        return false;
      }

      return true;
    }

    return false;
  }

  function getGap(track) {
    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
    return Number.isFinite(gap) ? gap : 0;
  }

  function initHomeFeaturedCarousel(root) {
    if (!root || root.dataset.homeFeaturedCarouselBound === '1') {
      return;
    }

    const viewport = root.querySelector('.home-featured-carousel-viewport');
    const track = root.querySelector('.home-featured-track');

    if (!viewport || !track) {
      return;
    }

    const cards = Array.from(track.querySelectorAll('.home-featured-card'));

    if (shouldUseStaticCarousel(root, cards.length, getSlidesPerView(root))) {
      root.classList.add('is-static');
      return;
    }

    root.dataset.homeFeaturedCarouselBound = '1';

    let slidesPerView = getSlidesPerView(root);
    let currentPage = 0;
    let pageCount = 1;
    let autoplayTimer = 0;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function applyTransform(animate) {
      const gap = getGap(track);
      const step = cards[0] ? cards[0].offsetWidth : 0;
      const offset = currentPage * (step + gap) * slidesPerView;

      track.classList.toggle('is-animating', animate && !reducedMotion);
      track.style.transform = 'translate3d(-' + offset + 'px, 0, 0)';
    }

    function layoutCarousel() {
      slidesPerView = getSlidesPerView(root);
      pageCount = Math.max(1, Math.ceil(cards.length / slidesPerView));

      if (currentPage > pageCount - 1) {
        currentPage = 0;
      }

      applyTransform(false);
    }

    function goToPage(page, animate) {
      if (pageCount <= 1) {
        return;
      }

      currentPage = (page + pageCount) % pageCount;
      applyTransform(animate !== false);
    }

    function stopAutoplay() {
      window.clearInterval(autoplayTimer);
      autoplayTimer = 0;
    }

    function startAutoplay() {
      stopAutoplay();

      if (reducedMotion || pageCount <= 1) {
        return;
      }

      autoplayTimer = window.setInterval(function () {
        goToPage(currentPage + 1);
      }, AUTOPLAY_MS);
    }

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', function (event) {
      if (event.relatedTarget instanceof Node && root.contains(event.relatedTarget)) {
        return;
      }
      startAutoplay();
    });

    if (typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(function () {
        layoutCarousel();
      });
      resizeObserver.observe(viewport);
    } else {
      window.addEventListener('resize', layoutCarousel);
    }

    window.requestAnimationFrame(function () {
      layoutCarousel();
      startAutoplay();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-home-featured-carousel]').forEach(initHomeFeaturedCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('[data-home-featured-carousel]');
    if (root) {
      initHomeFeaturedCarousel(root);
    }
  });
})();
